import { defaultColumns, defaultSort } from '../../components/processes/supplierReturnOrders/columns';

export default {
  state: {
    supplierReturnOrders: [],
    tableConfig: null,
    loading: false,
    currentPage: 1,
    filterString: null,
    sorting: {
      prop: 'created_at',
      order: 'asc',
    },
  },
  getters: {
    supplierReturnOrders: state => state.supplierReturnOrders,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    currentPage: state => state.currentPage,
  },
  mutations: {
    setSupplierReturnOrders(state, supplierReturnOrders) {
      state.supplierReturnOrders = supplierReturnOrders;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/supplier-return-order-list');
        const tableConfig = {
          id: setting.id || null,
          type: 'supplier-return-order-list',
          columns: setting.id ? JSON.parse(setting.config).columns : defaultColumns,
          sort: setting.id ? JSON.parse(setting.config).sort : defaultSort,
        };
        commit('setTableConfig', tableConfig);
      } catch (e) {
      }
    },
    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&comparetype=${state.sorting.compareType || 'string'}&${state.filterString}`;
        const supplierReturnOrders = await axios.get('api/supplier-return-orders' + (query || ''));
        commit('setSupplierReturnOrders', supplierReturnOrders);
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async search({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        return await axios.get('api/supplier-return-orders/search' + (queryString || ''));
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetch({ commit }, id) {
      return await axios.get(`api/supplier-return-orders/${id}`);
    },
    async search({ commit, state, dispatch }, queryString) {
      try {
        return await axios.get('api/supplier-return-orders/search' + (queryString || ''));
      } catch (e) {
      }
    },
    async create({ commit }, payLoad) {
      await axios.post('api/supplier-return-orders', payLoad);
    },
    async update({ commit }, payLoad) {
      await axios.put('api/supplier-return-orders', payLoad);
    },
    async send({ commit }, id) {
      await axios.post('api/supplier-return-orders/send/' + id);
    },
    async delete({ commit }, id) {
      await axios.delete(`api/supplier-return-orders/${id}`);
    },
    async excelExport({ commit }, { data, fileName, fileFormat }) {
      const excel = await axios({
        url: 'api/supplier-return-order-excel-export',
        method: 'POST',
        responseType: 'blob',
        data,
      });
      saveAs(excel, `${fileName.trim().split(' ').join('_') || 'SupplierReturnOrders'}.${fileFormat.toLocaleLowerCase() || 'xlsx'}`);
    },
  },
};
